
import React from 'react';
import { Input } from '@/components/ui/input';
import { Search } from 'lucide-react';

interface AdminSearchBarProps {
  searchTerm: string;
  onSearchChange: (term: string) => void;
}

const AdminSearchBar: React.FC<AdminSearchBarProps> = ({ searchTerm, onSearchChange }) => {
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onSearchChange(e.target.value);
  };

  return (
    <div className="relative flex-1 max-w-md">
      <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground h-4 w-4 z-10" />
      <Input
        type="text"
        placeholder="Search by name or email..."
        value={searchTerm}
        onChange={handleInputChange}
        className="pl-10 pr-4 h-10 bg-background border-border rounded-lg hover:bg-accent/5 transition-colors focus-visible:ring-1 focus-visible:ring-primary/20"
      />
    </div>
  );
};

export default AdminSearchBar;
